import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=9ec1df08&scoped=true&lang=pug"
import script from "./ModalBase.vue?vue&type=script&lang=ts"
export * from "./ModalBase.vue?vue&type=script&lang=ts"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=9ec1df08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec1df08",
  null
  
)

export default component.exports